import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useInView } from "../hooks/useInView";
import { Globe, Search } from "lucide-react";
import { Input } from "./ui/input";
import { LANGUAGES_ES, LANGUAGES_EN } from "../data/translations";

export default function Languages() {
    const { t, lang } = useLanguage();
    const [ref, inView] = useInView();
    const [search, setSearch] = useState("");

    const languages = lang === "es" ? LANGUAGES_ES : LANGUAGES_EN;
    const filtered = search
        ? languages.filter((l) => l.toLowerCase().includes(search.toLowerCase()))
        : languages;

    return (
        <section id="idiomas" className="py-20 md:py-32 px-6" ref={ref} data-testid="languages-section">
            <div className={`max-w-7xl mx-auto ${inView ? "animate-fade-in-up" : "opacity-0"}`}>
                <div className="text-center mb-12">
                    <div className="inline-flex items-center gap-2 bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 px-4 py-1.5 rounded-full text-sm font-medium mb-4">
                        <Globe className="w-4 h-4" />
                        {t.languages.title}
                    </div>
                    <h2 className="text-3xl md:text-4xl font-semibold tracking-tight">
                        {t.languages.title}
                    </h2>
                    <p className="mt-4 text-base md:text-lg text-slate-500 dark:text-slate-400 max-w-2xl mx-auto">
                        {t.languages.subtitle}
                    </p>
                </div>

                <div className="max-w-md mx-auto mb-8">
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                        <Input
                            placeholder={t.languages.search}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="pl-10 h-11"
                            data-testid="language-search"
                        />
                    </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-2.5">
                    {filtered.map((language) => (
                        <div
                            key={language}
                            className="text-sm px-3 py-2.5 rounded-lg bg-white dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800 text-center hover:border-blue-300 dark:hover:border-blue-600 hover:shadow-sm transition-all duration-200"
                        >
                            {language}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
